import { render, staticRenderFns } from "./approvedToSend.vue?vue&type=template&id=a5dcf8da"
import script from "./approvedToSend.vue?vue&type=script&lang=js"
export * from "./approvedToSend.vue?vue&type=script&lang=js"
import style0 from "./approvedToSend.vue?vue&type=style&index=0&id=a5dcf8da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports